import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Cancel18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_527)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 0.25C4.16751 0.25 0.25 4.16751 0.25 9C0.25 13.8325 4.16751 17.75 9 17.75C13.8325 17.75 17.75 13.8325 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25ZM1.75 9C1.75 4.99594 4.99594 1.75 9 1.75C10.7319 1.75 12.3219 2.35726 13.5688 3.37046L3.37046 13.5688C2.35726 12.3219 1.75 10.7319 1.75 9ZM4.43112 14.6295C5.67803 15.6427 7.2681 16.25 9 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 7.2681 15.6427 5.67803 14.6295 4.43111L4.43112 14.6295Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_527'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Cancel18.displayName = 'Cancel18';
export default Cancel18;
